// src/components/Icones.js
import React from "react";

// Lupa desenhada em SVG, na cor do texto em volta (currentColor). Com `mais`,
// ganha um "+" num círculo sobre o canto, para indicar "acrescentar busca".
export function Lupa({ mais = false, className = "" }) {
  return (
    <svg className={`icone-lupa ${className}`} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="10" cy="10" r="6" />
      <path d="M14.5 14.5 20 20" />
      {mais && (
        <g className="icone-lupa-mais">
          <circle cx="18" cy="6" r="5" />
          <path d="M18 3.5v5M15.5 6h5" />
        </g>
      )}
    </svg>
  );
}
